<template>
  <label
    :class="_class"
    v-on="$listeners"
  >
    <span :class="_classItem">
      <input
        v-bind="$attrs"
        @change.stop="onChange"
        type="checkbox"
        :checked="indeterminate ? false : _checked"
        :indeterminate="indeterminate"
        :name="name"
        :disabled="_disabled"
        :value="value"
      >
      <span class="ten-checkbox__checkbox-inner" />
    </span>
    <slot />
  </label>
</template>
<script>
const name = 'ten-checkbox';
export default {
  name,
  inject: {
    group: {
      default: undefined,
    },
    formItem: {
      from: 'tenFormItem',
      default: null,
    },
  },
  props: {
    /**
     * 是否禁用
     */
    disabled: Boolean,
    /**
     * 单选的值，对应原生 input 的 value 属性
     */
    value: [String, Number, Boolean],
    /**
     * 是否为半选中状态
     */
    indeterminate: {
      type: Boolean,
      default: false,
    },
    /**
     * 对应原生 input 的 name 属性
     */
    name: String,
    /**
     * @model
     *
     * v-model 是否选中，对应事件 change
     */
    checked: {
      type: Boolean,
      default: false,
    },
    /**
     * 默认是否选中
     */
    defaultChecked: [String, Number, Boolean],
  },
  computed: {
    _class() {
      return [
        `${name}`,
        {
          [`${name}--disabled`]: this._disabled,
        },
      ];
    },
    _classItem() {
      return [`${name}__checkbox`];
    },
    _disabled() {
      if (this.group && this.group.disabled) {
        return true;
      }
      return this.disabled;
    },
    _checked() {
      if (this.group && this.group.value) {
        return this.group.value.indexOf(this.value) > -1;
      }
      return this.checked;
    },
  },
  methods: {
    onChange(event) {
      const { checked } = event.target;
      event.target.checked = this._checked;
      if (this.group) {
        this.group.$emit('memberChange', { value: this.value, checked });
      } else {
        /**
         * 选中变化
         * @param { boolean } checked 是否选中
         */
        this.$emit('change', checked);
        this.formItem && this.formItem.$emit('form.change');
      }
    },
  },
};
</script>
